var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16654 6.80768L5.4082 3.04935C6.72487 2.17435 8.29987 1.66602 9.99987 1.66602C14.5999 1.66602 18.3332 5.39935 18.3332 9.99935C18.3332 11.6993 17.8249 13.2743 16.9499 14.591L15.7332 13.3743C16.3249 12.391 16.6665 11.2327 16.6665 9.99935C16.6665 7.20768 14.9415 4.81602 12.4999 3.82435V4.16602C12.4999 5.08268 11.7499 5.83268 10.8332 5.83268H9.16654V6.80768ZM17.6582 17.6577L16.4832 18.8327L14.5915 16.941C13.2749 17.8244 11.6999 18.3327 9.99987 18.3327C5.39987 18.3327 1.66654 14.5993 1.66654 9.99935C1.66654 8.29935 2.17487 6.72435 3.04987 5.40768L1.1582 3.51602L2.3332 2.34102L17.6582 17.6577ZM9.16654 14.9993C8.24987 14.9993 7.49987 14.2493 7.49987 13.3327V12.4993L3.5082 8.50768C3.39987 8.99102 3.3332 9.48268 3.3332 9.99935C3.3332 13.3993 5.87487 16.1994 9.16654 16.6077V14.9993Z",
    fill: "#292929",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublish);
export default __webpack_public_path__ + "static/media/unpublish.9071782df0df89ae6730c7b810a5e21e.svg";
export { ForwardRef as ReactComponent };